/* Gaiety Gems: reveal, parallax, hero video and stone scroller */
(function () {
  document.documentElement.classList.add('gg-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.gg-reveal:not(.is-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  var parallaxItems = [];
  var ticking = false;
  function updateParallax() {
    parallaxItems.forEach(function (el) {
      var box = el.parentElement.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      el.style.transform = 'translate3d(0,' + (box.top * -0.16).toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  function parallax() {
    if (reduce) return;
    parallaxItems = Array.prototype.slice.call(document.querySelectorAll('[data-gg-parallax]'));
    updateParallax();
  }
  window.addEventListener('scroll', function () {
    if (!ticking && parallaxItems.length) { window.requestAnimationFrame(updateParallax); ticking = true; }
  }, { passive: true });

  function heroVideo(root) {
    (root || document).querySelectorAll('.gg-hero video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function scrollers(root) {
    (root || document).querySelectorAll('[data-gg-scroller]').forEach(function (wrap) {
      if (wrap.dataset.ggReady) return;
      wrap.dataset.ggReady = '1';
      var track = wrap.querySelector('.gg-stones__track');
      wrap.querySelectorAll('[data-gg-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-gg-dir') === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function init(root) { reveal(root); parallax(); heroVideo(root); scrollers(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();